<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('service-banner-table')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">New Banner</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="title"
        >
        </base-input>
        <base-input
          alternative
          class="mb-3"
          name="Description"
          :rules="{ required: true }"
          placeholder="Description"
          v-model="body"
        >
        </base-input>

        <base-input
          alternative
          class="mb-3"
          name="Button Name"
          :rules="{ required: true }"
          placeholder="Button Name"
          v-model="buttonName"
        >
        </base-input>
        <base-input
          alternative
          class="mb-3"
          name="Redirect To"
          :rules="{ required: true }"
          placeholder="Redirect To"
          v-model="redirectTo"
        >
        </base-input>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />

        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
        <img v-if="image" :src="image" ref="cover" />
        <!-- <quill-editor
          v-model="body"
          :options="editorOption"
          class="quill-h200px my-2"
        /> -->

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import _ from "lodash";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      image: null,
      coverImage: null,
      body: "",
      buttonName: "",
      redirectTo: "",
      editorOption: {
        theme: "snow",
      },
      imageErr: false,
      msg: {},
    };
  },

  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("heading", this.title);
      data.append("image", this.coverImage);
      data.append("discription", this.body);
      data.append("redirectTo", this.redirectTo);
      data.append("buttonName", this.buttonName);
      let loader = this.$loading();

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image or Upload SVG Image only",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const blogdata = await this.$store.dispatch(
          "services/createbanner",
          data
        );
        // if (blogdata.code == 200) {
        this.$router.push({ name: "service-banner-table" });
        this.$swal.fire({
          title: "Congratulations!",
          text: "Your banner has been successfully added to the website",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },

    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
